module.exports = __webpack_public_path__ + "static/media/Standaardbijlage Marcom B 2018-2019.bf1a1a02.pdf";